import React from 'react';
import Icon from './Icon';

const AddPlotIcon = (props) => (
    <Icon {...props}>
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
    </Icon>
);

export default AddPlotIcon;
